module.exports = "/_next/static/images/btn_spr.Hwm7UgOw.png";